import { createSelector } from 'reselect'
import _get from 'lodash/get'

export const get_draft_events = createSelector(state => _get(state, 'draftEvents.draftEvents'))

export default get_draft_events
